import { countryActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case countryActions.COUNTRIES_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case countryActions.COUNTRIES_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case countryActions.COUNTRIES_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: true,
        error: null
      };
    case countryActions.COUNTRIES_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: true,
        error: null
      };
    case countryActions.COUNTRIES:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case countryActions.COUNTRIES_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
